module.exports = __webpack_public_path__ + "static/media/plus-add.4eb250af.svg";